import Loader from 'components/Loader';
import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const StatsLoader = ({ isLoading, children }) => {
  return (
    <div className="StatsLoader-bg">
      {isLoading ? (
        <div className="StatsLoader">
          <Loader isLoading={isLoading} />
        </div>
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

StatsLoader.defaultProps = {
  isLoading: false,
  children: null,
};

StatsLoader.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

export default StatsLoader;
